function normalizeEdges(list) {
  return (list?.edges ?? []).map(({ node }) => node);
}

export default normalizeEdges;
